import "core-js/stable";
import "regenerator-runtime/runtime";

import React from "react";
import { hydrate } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import getClient from "./lib/apollo";
import App from "./routes/App";
import { ChakraProvider } from "@chakra-ui/react";

const client = getClient();

hydrate(
  <ChakraProvider resetCSS={false}>
    <Router basename="/admin">
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </Router>
  </ChakraProvider>,
  document.getElementById("root")
);
